export default __webpack_public_path__ + "aixmarseille.c0b8fde.png";